module.exports = "/_next/static/images/forestryGlobe-26660f75a96fb43dbd1e56e80ae77637.png.webp";